import Navigation from "@/components/Navigation";
import AboutHero from "@/components/about/AboutHero";
import AboutContent from "@/components/about/AboutContent";

const About = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <AboutHero />
            <AboutContent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;